import React, {useState} from "react";
import PhoneStep from "./PhoneStep";
import OtpStep from "./OtpStep";

const STEP_PHONE = "phone";
const STEP_OTP = "otp";

const noopAsync = async () => ({success: true});

const ExternalLogin = ({
                           backgroundImage,
                           userType,
                           title = "All your restaurant needs delivered next day",
                           otpLength = 6,
                           resendSeconds = 30,
                           termsHref,
                           onSendOtp = noopAsync,
                           onVerifyOtp = noopAsync,
                           onLoginSuccess,
                       }) => {
    const [step, setStep] = useState(STEP_PHONE);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [otp, setOtp] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const sendOtp = async () => {
        setErrorMessage("");
        setIsSubmitting(true);
        try {
            const res = await onSendOtp({phoneNumber, userType});
            if (res?.success === false) {
                setErrorMessage(res.message || "Failed to send OTP");
                return;
            }
            setStep(STEP_OTP);
            setOtp("");
        } catch (err) {
            setErrorMessage(err?.message || "Failed to send OTP");
        } finally {
            setIsSubmitting(false);
        }
    };

    const verifyOtp = async () => {
        setErrorMessage("");
        setIsSubmitting(true);
        try {
            const res = await onVerifyOtp({phoneNumber, otp, userType});
            if (res?.success === false) {
                setErrorMessage(res.message || "Invalid OTP");
                return;
            }
            onLoginSuccess?.({phoneNumber, userType});
        } catch (err) {
            setErrorMessage(err?.message || "Invalid OTP");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleBackToPhone = () => {
        setErrorMessage("");
        setOtp("");
        setStep(STEP_PHONE);
    };

    if (step === STEP_OTP) {
        return (
            <OtpStep
                phoneNumber={phoneNumber}
                otp={otp}
                onOtpChange={setOtp}
                otpLength={otpLength}
                resendSeconds={resendSeconds}
                onResend={sendOtp}
                onVerify={verifyOtp}
                onBack={handleBackToPhone}
                isSubmitting={isSubmitting}
                errorMessage={errorMessage}
                termsHref={termsHref}
            />
        );
    }

    return (
        <PhoneStep
            backgroundImage={backgroundImage}
            title={title}
            phoneNumber={phoneNumber}
            onPhoneChange={setPhoneNumber}
            onContinue={sendOtp}
            isSubmitting={isSubmitting}
            errorMessage={errorMessage}
        />
    );
};

export default ExternalLogin;
